import {createAsyncAction, createAction} from 'typesafe-actions';
import {AccountListResponse} from "../../types/Account";
import {GetHuntGroupListResponse} from "../ringgroups/payloads";
import {AssignedExtension} from "../../types/RingGroup";
import {AgentListFilters} from "../../../components/Tabs/Agents/FiltersComponent";

export const getAgentsTabData = createAsyncAction(
    'GET_AGENTS_TAB_DATA',
    'GET_AGENTS_TAB_DATA_SUCCESSES',
    'GET_AGENTS_TAB_DATA_FAILED',
)<AgentListFilters, {
    accounts: AccountListResponse,
    huntGroupList: GetHuntGroupListResponse,
    agents: AssignedExtension[]
}, undefined>();

export const fetchRestOfAccountsForAgentTab = createAsyncAction(
    'FETCH_REST_OF_EXTENSTION_AT_AGENTS_TAB',
    'FETCH_REST_OF_EXTENSTION_AT_AGENTS_TAB_SUCCESSES',
    'FETCH_REST_OF_EXTENSTION_AT_AGENTS_TAB_FAILED',
)<undefined, {
    accounts: AccountListResponse
}, undefined>();

export const cacheAgents = createAction('CACHE_AGENTS')<{agents: AssignedExtension[]}>();
export const participantId = createAction('PARTICIPATION_ID')<{id?: string}>();
